import {BreadcrumbItem} from "../../DashboardNew/BreadcrumbHeader";
import React from "react";
import {Breadcrumb} from "flowbite-react";

interface BreadcrumbsHeaderProps {
  breadcrumbs: BreadcrumbItem[];
  onBreadcrumbClick?: (index: number, item: BreadcrumbItem) => void;
}

const BreadcrumbsHeader: React.FC<BreadcrumbsHeaderProps> = ({
  breadcrumbs,
  onBreadcrumbClick,
}) => {
  return (
    <Breadcrumb>
      {breadcrumbs.map((item, index) => {
        return (
          <Breadcrumb.Item
            key={index}
            className={`${item.active ? 'text-light-text-secondary dark:text-gray-400' : 'cursor-pointer'} min-w-0 flex items-center`}
            onClick={!item.active && onBreadcrumbClick ? () => onBreadcrumbClick(index, item) : undefined}
          >
            <span
              className={`${item.active
                ? "text-light-text-secondary dark:text-gray-400 font-medium"
                : "text-primary-light dark:text-blue-500 font-medium hover:underline cursor-pointer"} 
                inline-block truncate align-middle`}
              onClick={!item.active && onBreadcrumbClick ? () => onBreadcrumbClick(index, item) : undefined}
            >
              {item.label}
            </span>
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
};

export default BreadcrumbsHeader;
